export const blockIconsHomePropaneTank = (
	<span className='material-symbols-outlined'>propane_tank</span>
);
